export const RoomMap = (props: { enabled: boolean; roomMapObj: any }) => {
  const { enabled, roomMapObj } = props;

  return roomMapObj && roomMapObj.cachedRoom ? (
    <div
      className={`quote-map ${enabled ? "" : "quote-map-hidden"}`}
      style={{ animation: enabled ? "fadein 0.5s" : undefined }}
    >
      {roomMapObj.cachedRoom}
    </div>
  ) : null;
};